// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"adc6c797","17":"25af41ef","205":"0f5b50e6","247":"b965bcd5","444":"676e72b2","521":"7beaa538","755":"6ea600da","899":"7faad74b","955":"8450e133"}[chunkId] + ".chunk.js";
};